import React from "react";

// Renamed section: "A role-to-role protocol in four moves".
// Retained journey cards labelled: Request · Custody · Authorised decision · Receipt.

const STEPS = [
  {
    n: "01",
    label: "Request",
    body: "A bounded request is made.",
  },
  {
    n: "02",
    label: "Custody",
    body: "Evidence stays with its custodian.",
  },
  {
    n: "03",
    label: "Authorised decision",
    body: "The authorised role approves, refuses or escalates.",
  },
  {
    n: "04",
    label: "Receipt",
    body: "A receipt records the governed outcome.",
  },
];

export const WhatKatlasChanges = () => {
  return (
    <section
      id="role-to-role"
      data-testid="section-role-to-role"
      className="relative py-20 lg:py-28 border-t border-white/[0.06] bg-[#040F1B]"
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#0066FF]">
            Role-to-role protocol
          </div>
          <h2
            data-testid="role-to-role-headline"
            className="font-display text-3xl sm:text-4xl lg:text-[44px] mt-4 leading-[1.08]"
          >
            A role-to-role protocol{" "}
            <span className="text-slate-400">in four moves.</span>
          </h2>
          <p className="mt-5 text-sm sm:text-base text-slate-300 leading-relaxed">
            Request the decision, not blanket access. Authority and proof
            travel where they are needed; sensitive evidence stays with its
            custodian.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/[0.06] border border-white/[0.06]">
          {STEPS.map((s, i) => (
            <article
              key={s.n}
              data-testid={`step-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-[#020B14] p-6 lg:p-7 flex flex-col"
            >
              <div className="flex items-baseline gap-3">
                <span
                  className={`font-display text-4xl leading-none ${
                    i === STEPS.length - 1
                      ? "text-[#EAB308]"
                      : "text-[#0066FF]"
                  }`}
                >
                  {s.n}
                </span>
                <span className="mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
                  Move
                </span>
              </div>
              <h3 className="mt-6 font-display text-lg text-white leading-snug">
                {s.label}
              </h3>
              <p className="mt-2 text-sm text-slate-300 leading-relaxed">
                {s.body}
              </p>
            </article>
          ))}
        </div>

        <p
          data-testid="role-to-role-support"
          className="mt-8 text-sm sm:text-base text-slate-300 leading-relaxed max-w-3xl"
        >
          KATLAS records the governed action,{" "}
          <span className="text-[#EAB308]">
            not a copy of everyone&apos;s private data.
          </span>
        </p>
      </div>
    </section>
  );
};
